import React from 'react';
import {
  RiTwitterXLine,
  RiInstagramLine,
  RiFacebookCircleLine,
} from 'react-icons/ri';

export default function SocialLinks() {
  return (
    <div className='text-center'>
      <p>Follow me on</p>

      <div>
        <a
          href='https://www.facebook.com/authorjanecorry/'
          target='_blank'
          rel='noreferrer'
          className='p-3 contactlink'>
          <RiFacebookCircleLine className='contactlinkicon' />
        </a>

        <a
          href='https://www.instagram.com/janecorry'
          target='_blank'
          rel='noreferrer'
          className='p-3 contactlink'>
          <RiInstagramLine className='contactlinkicon' />
        </a>

        <a
          href='https://twitter.com/JaneCorryAuthor'
          target='_blank'
          rel='noreferrer'
          className='p-3 contactlink'>
          <RiTwitterXLine className='contactlinkicon' />
        </a>
      </div>
    </div>
  );
}
